export { Application, MULTI_PRODUCTS_APPS } from "@common/utils/src/utils/application";
